import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex flex-col bg-neutral-50 dark:bg-neutral-900 overflow-hidden" }
const _hoisted_2 = { class: "flex-1 flex items-center justify-center p-6 lg:p-12" }
const _hoisted_3 = { class: "max-w-5xl w-full flex flex-col lg:flex-row items-center justify-center gap-16 lg:gap-32" }
const _hoisted_4 = { class: "relative w-80 h-80 shrink-0 flex items-center justify-center animate-enter-up" }
const _hoisted_5 = { class: "relative z-10 font-bold text-9xl text-neutral-900/10 dark:text-white/10 select-none" }
const _hoisted_6 = { class: "text-center lg:text-left max-w-lg animate-enter-up delay-200" }
const _hoisted_7 = { class: "space-y-6" }
const _hoisted_8 = { class: "inline-flex items-center px-3 py-1 rounded-full bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 text-sm font-medium border border-neutral-200 dark:border-neutral-700 shadow-sm" }
const _hoisted_9 = { class: "text-4xl lg:text-5xl font-bold tracking-tight text-neutral-900 dark:text-white" }
const _hoisted_10 = { class: "text-lg text-neutral-500 dark:text-neutral-400 leading-relaxed" }
const _hoisted_11 = { class: "flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-2" }

import type { NuxtError } from "#app";


export default /*@__PURE__*/_defineComponent({
  __name: 'error',
  props: {
    error: {}
  },
  setup(__props: any) {

definePageMeta({
  layout: "default",
  pageTransition: { name: "page", mode: "out-in" },
});



useHead({
  htmlAttrs: {
    lang: "en",
  },
});

const handleError = () => clearError({ redirect: "/" });

const message = ref("Looks like something is missing");

return (_ctx: any,_cache: any) => {
  const _component_TopHeader = _resolveComponent("TopHeader")!
  const _component_UButton = _resolveComponent("UButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_TopHeader),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(__props.error?.statusCode), 1),
          _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"absolute top-4 left-0 animate-enter-pop\" style=\"animation-delay:0.1s;\" data-v-9f3c53a0><div class=\"w-24 h-24 rounded-full bg-group_rose-300 dark:bg-group_rose-700 animate-float-1 opacity-90\" data-v-9f3c53a0></div></div><div class=\"absolute bottom-8 -right-4 animate-enter-pop\" style=\"animation-delay:0.3s;\" data-v-9f3c53a0><div class=\"w-20 h-20 rounded-3xl bg-group_blue-300 dark:bg-group_blue-700 animate-float-2 opacity-90\" data-v-9f3c53a0></div></div><div class=\"absolute -top-6 right-6 animate-enter-pop\" style=\"animation-delay:0.5s;\" data-v-9f3c53a0><div class=\"w-28 h-28 animate-float-3 opacity-90\" data-v-9f3c53a0><svg viewBox=\"0 0 100 100\" class=\"w-full h-full fill-group_yellow-300 dark:fill-group_yellow-700\" data-v-9f3c53a0><polygon points=\"50,15 90,85 10,85\" data-v-9f3c53a0></polygon></svg></div></div><div class=\"absolute top-1/4 right-0 animate-enter-pop\" style=\"animation-delay:0.7s;\" data-v-9f3c53a0><div class=\"w-4 h-4 rounded-full bg-group_emerald-300 dark:bg-group_emerald-600 animate-float-1\" style=\"animation-duration:8s;\" data-v-9f3c53a0></div></div><div class=\"absolute bottom-1/4 -left-8 animate-enter-pop\" style=\"animation-delay:0.8s;\" data-v-9f3c53a0><div class=\"w-3 h-3 rounded-full bg-group_purple-300 dark:bg-group_purple-600 animate-float-3\" style=\"animation-duration:11s;\" data-v-9f3c53a0></div></div><div class=\"absolute top-0 right-1/3 animate-enter-pop\" style=\"animation-delay:0.9s;\" data-v-9f3c53a0><div class=\"w-5 h-5 rounded-full bg-group_orange-300 dark:bg-group_orange-600 animate-float-2\" style=\"animation-duration:14s;\" data-v-9f3c53a0></div></div><div class=\"absolute bottom-2 left-12 animate-enter-pop\" style=\"animation-delay:0.6s;\" data-v-9f3c53a0><div class=\"text-5xl font-bold text-neutral-400/50 dark:text-neutral-500/50 animate-float-2\" data-v-9f3c53a0> 1 </div></div><div class=\"absolute top-1/2 -right-8 animate-enter-pop\" style=\"animation-delay:0.7s;\" data-v-9f3c53a0><div class=\"text-3xl font-bold text-neutral-400/50 dark:text-neutral-500/50 animate-float-1\" data-v-9f3c53a0> 0 </div></div><div class=\"absolute -bottom-8 right-1/3 animate-enter-pop\" style=\"animation-delay:0.8s;\" data-v-9f3c53a0><div class=\"text-4xl font-bold text-neutral-400/50 dark:text-neutral-500/50 animate-float-3\" data-v-9f3c53a0> ? </div></div>", 9))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[1] || (_cache[1] = _createElementVNode("span", { class: "w-2 h-2 rounded-full bg-red-500 mr-2 animate-pulse" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(__props.error?.statusCode === 404 ? "Page Not Found" : "An Error Occurred"), 1)
            ]),
            _createElementVNode("h1", _hoisted_9, _toDisplayString(__props.error?.name || __props.error?.statusMessage || "Something went wrong"), 1),
            _createElementVNode("p", _hoisted_10, _toDisplayString(__props.error?.message && __props.error.message !== (__props.error.name || __props.error.statusMessage)
                  ? __props.error.message
                  : _unref(message)), 1),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_UButton, {
                color: "primary",
                size: "lg",
                icon: "i-heroicons-arrow-left",
                onClick: handleError
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode(" Go back home ", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})